import React, { Component } from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import Title from '../components/title'
import Description from '../components/description'
import AnimatedBorder from '../components/animated-border'
import MoreProjects from '../components/more-projects'
import { shuffle } from '../utils'
import { mobile, tablet, desktop } from '../utils/media'
const R = require('ramda')

class BlogPostTemplate extends Component {
  state = { doAnimation: false }

  componentDidMount() {
    setTimeout(() => { this.setState({ doAnimation: true }) }, 100)
  }

  render() {
    const {
      data: {
        site,
        markdownRemark: {
          frontmatter,
          html
        },
        allMarkdownRemark: {
          edges
        }
      },
      location: {
        pathname
      }
    } = this.props

    const uniqPosts = R.filter(edge => {
      return edge.node.frontmatter.path !== pathname
    }, edges)

    return (
      <div>
        <Helmet title={`${frontmatter.title} | ${site.siteMetadata.title}`} />
        <Hero>
          <Text>
            <Title>{frontmatter.title}</Title>
            <Description>{frontmatter.description}</Description>
          </Text>
          <AnimatedBorder doAnimation={this.state.doAnimation} />
          <ResponsiveImage sizes={frontmatter.preview.childImageSharp.sizes} />
        </Hero>
        <Photos dangerouslySetInnerHTML={{ __html: html }} />
        <MoreProjects projects={shuffle(uniqPosts).slice(0, 4)} />
      </div>
    )
  }
}

const Hero = styled.section`
  position: relative;
  width: 100%;
  height: 150px;
  overflow: hidden;

  ${mobile`
    height: 400px;
  `}

  ${tablet`
    height: 500px;
  `}

  ${desktop`
    height: 600px;
  `}
`

const Text = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  opacity: .7;
  background: #000;
`

const Photos = styled.div`
  > p {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0;
    padding: 0 4.42%;

    > span {
      margin: 50px auto 0;
      width: 90vw;

      ${tablet`
        :nth-child(1),
        :nth-child(5),
        :nth-child(9),
        :nth-child(13),
        :nth-child(17),
        :nth-child(21),
        :nth-child(25),
        :nth-child(29),
        :nth-child(33),
        :nth-child(37),
        :nth-child(41) {
          margin: 50px 0 0;
          width: 45vw;
        }

        :nth-child(2),
        :nth-child(6),
        :nth-child(10),
        :nth-child(14),
        :nth-child(18),
        :nth-child(22),
        :nth-child(26),
        :nth-child(30),
        :nth-child(34),
        :nth-child(38),
        :nth-child(42) {
          position: relative;
          bottom: -149px;
          padding-top: 50px;
          margin: 0;
          width: 40vw;
          border-top: 1px solid #fff;
        }

        :nth-child(3),
        :nth-child(7),
        :nth-child(11),
        :nth-child(15),
        :nth-child(19),
        :nth-child(23),
        :nth-child(27),
        :nth-child(31),
        :nth-child(35),
        :nth-child(39),
        :nth-child(43) {
          padding-bottom: 90px;
          margin: 80px 0 0;
          width: 45vw;
          border-bottom: 1px solid #ffffff;
        }

        :nth-child(4),
        :nth-child(8),
        :nth-child(12),
        :nth-child(16),
        :nth-child(20),
        :nth-child(24),
        :nth-child(28),
        :nth-child(32),
        :nth-child(36),
        :nth-child(40),
        :nth-child(44) {
          position: relative;
          bottom: -100px;
          margin: 90px 0 0;
          width: 40vw;
        }
      `}
    }
  }
`

const ResponsiveImage = styled(Img)`
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        path
        preview {
          childImageSharp {
            sizes(maxWidth: 1200, maxHeight: 600, cropFocus: CENTER) {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          frontmatter {
            path
            date(formatString: "DD MMMM, YYYY")
            title
            description
            thumb {
              childImageSharp {
                sizes(maxWidth: 300, maxHeight: 300, cropFocus: CENTER) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js